export default __webpack_public_path__ + "static/media/argon-react.fc3676a1.png";